import { render, staticRenderFns } from "./SensorineuralConsentContainer.vue?vue&type=template&id=4f005332"
import script from "./SensorineuralConsentContainer.vue?vue&type=script&lang=js"
export * from "./SensorineuralConsentContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports